module.exports = __webpack_public_path__ + "static/media/gtx_printer.97aa794a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gtx_printer.png
// module id = 157
// module chunks = 0